import type { Asset } from '@schibsted-svp/svp-api-types';

const getDefaultAssetLabel = (asset: {
  title: Asset['title'];
  category: {
    title?: Asset['category']['title'];
    isSeries?: Asset['category']['isSeries'];
  };
  series: Asset['series'];
}) => {
  const { category, series } = asset;

  const categoryTitle = category.title;

  const season = series?.seasonNumber;
  const episode = series?.episodeNumber;

  if (category.isSeries && season && episode) {
    return `${categoryTitle} · S${season}, E${episode}`;
  }

  return categoryTitle;
};

const getAssetLabelInSeasonContext = (asset: {
  title: Asset['title'];
  category: {
    title?: Asset['category']['title'];
    isSeries?: Asset['category']['isSeries'];
  };
  series: Asset['series'];
}) => {
  const { series } = asset;

  const episode = series?.episodeNumber;

  if (episode) {
    return `episode ${episode}`;
  }

  return '';
};

export type AssetContext = 'none' | 'season';

export const getAssetLabel = (
  asset: {
    title: Asset['title'];
    category: {
      title?: Asset['category']['title'];
      isSeries?: Asset['category']['isSeries'];
    };
    series: Asset['series'];
  },
  context: AssetContext = 'none'
) => {
  if (context === 'season') {
    return getAssetLabelInSeasonContext(asset);
  }

  return getDefaultAssetLabel(asset);
};
